import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/reminder_history.svg';

const RemainderHistory = (props: any): ReactElement => {
  return <img src={icon} {...props} height={'20px'} width={'20px'} />;
};

export default RemainderHistory;
